/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-06-30 14:45:25
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-04-21 17:23:56
 * @FilePath: \bee-transport-h5-v1.0.3d:\project\mobile-map\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import App from './App';
import VueBus from 'vue-bus';
import { router } from './router';
import store from '@/store/index.js';
import './assets/style/global.scss';
import '@/utils/prototype-function';
import { tansParamsNotEnCode ,
  deepClone ,
  debounce ,
  createMap ,
  cityNameFormat ,
  createGeolocation ,
  handleGetLocation ,
  watchPosition ,
  clearWatch ,
  loading ,
  zeroPadding ,
  queryParams ,
  sleep,
  format
} from './utils/index';
import {$math} from '@/utils/math';
import '@/assets/fonts/index.css';
import '@/assets/iconfont/iconfont.css';
import { getToken } from './utils/auth';
import { Toast , Dialog,Popup , ImagePreview } from 'vant'
import { Step, Steps, Uploader  } from 'vant';
import 'vant/lib/index.css';
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import test from "@/utils/test.js";
import websocket from '@/utils/websocket.js';

Date.prototype.format = format;


Vue.component('Splitpanes',Splitpanes)
Vue.component('Pane',Pane)

/** 全局方法挂载 */
Vue.prototype.tansParamsNotEnCode = tansParamsNotEnCode;
Vue.prototype.deepClone = deepClone;
Vue.prototype.debounce = debounce;
Vue.prototype.createMap = createMap;
Vue.prototype.getToken = getToken;
Vue.prototype.cityNameFormat = cityNameFormat;
Vue.prototype.createGeolocation = createGeolocation;
Vue.prototype.handleGetLocation = handleGetLocation;
Vue.prototype.watchPosition = watchPosition;
Vue.prototype.clearWatch = clearWatch;
Vue.prototype.$loading = loading();
Vue.prototype.$zeroPadding = zeroPadding;
Vue.prototype.$queryParams = queryParams;
Vue.prototype.$test = test;
Vue.prototype.$math = $math;
Vue.prototype.$sleep = sleep;
Vue.prototype.$uniScoketInit = websocket.uniScoketInit;
Vue.prototype.$uniSocketClose = websocket.weixincustomerSocketClose;


Vue.use(Toast);
Vue.use(ImagePreview);
Vue.use(Dialog).use(Step).use(Steps).use(Uploader).use(Popup );
Vue.use(VueBus);

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
});
